import React from "react";
import { StripeCreditCardFieldTemplate } from "themes/common/components";

function StripeCreditCardField(props) {
    return <StripeCreditCardFieldTemplate {...props} />;
}

export default StripeCreditCardField;
